import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('nav') && !event.target.closest('.hamburger')) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header>
      <div className="container header-container">
        <div className="logo">
          <NavLink to="/">
            <img src="/images/logo-trojlistek.png" alt="Maryam Logo" />
          </NavLink>
        </div>
        
        <nav>
          <ul className={menuOpen ? 'show' : ''}>
            <li>
              <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>
                O škole
              </NavLink>
            </li>
            <li>
              <NavLink to="/pruvodci" className={({ isActive }) => isActive ? "active" : ""}>
                Průvodci
              </NavLink>
            </li>
            <li>
              <NavLink to="/prostory" className={({ isActive }) => isActive ? "active" : ""}>
                Prostory
              </NavLink>
            </li>
            <li>
              <NavLink to="/cenik" className={({ isActive }) => isActive ? "active" : ""}>
                Ceník
              </NavLink>
            </li>
            <li>
              <NavLink to="/kontakty" className={({ isActive }) => isActive ? "active" : ""}>
                Kontakty
              </NavLink>
            </li>
            <li className="login-item">
              <a
                href="https://moje.skola-maryam.cz"
                target="_blank"
                rel="noopener noreferrer"
                className="login-btn"
              >
                Přihlášení
              </a>
            </li>
          </ul>
        </nav>
      </div>
      
      {/* Mobile hamburger menu - outside the header container for fixed positioning */}
      <button 
        className="hamburger" 
        onClick={toggleMenu} 
        aria-label="Menu" 
        type="button"
      >
        {menuOpen ? 'Zavřít' : 'Menu'}
      </button>
    </header>
  );
};

export default Header; 